export const BUSY_TYPES = {
    LOAD: "load",
    SAVE: "save",
};

export const CALC_STATUSES = {
    PENDING: "pending",
    ERROR: "error",
    SUCCESS: "success",
};
